export default "__VITE_ASSET__BEf0dlfZ__"